function hasClass(elem, className) {
    return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
}

function addClass(elem, className) {
    if (!hasClass(elem, className)) {
        elem.className += ' ' + className;
    }
}

function removeClass(elem, className) {
    var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
    if (hasClass(elem, className)) {
        while (newClass.indexOf(' ' + className + ' ') >= 0) {
            newClass = newClass.replace(' ' + className + ' ', ' ');
        }
        elem.className = newClass.replace(/^\s+|\s+$/g, '');
    }
}

function displayBarNotification(message, isSuccess) {
    var messages = typeof message === 'string' ? [message] : message;
    if (messages.length === 0)
        return;

    //types: success, error, warning
    var cssclass = isSuccess ? 'success' : 'warning'

    //remove previous CSS classes and notifications
    removeClass(document.querySelector('#bar-notification'), 'success');
    removeClass(document.querySelector('#bar-notification'), 'error');
    removeClass(document.querySelector('#bar-notification'), 'warning');

    //add new notifications
    var htmlcode = document.createElement('div');
    htmlcode.classList.add('bar-notification', cssclass);

    //add close button for notification
    var close = document.createElement('span');
    close.classList.add('close');
    close.setAttribute('title', document.getElementById('bar-notification').dataset.close);

    for (var i = 0; i < messages.length; i++) {
        var content = document.createElement('p');
        content.classList.add('content');
        content.innerHTML = messages[i];

        htmlcode.append(content);
    }
    
    htmlcode.append(close);

    document.querySelector('#bar-notification')
        .append(htmlcode);

    htmlcode.style.animation = 'fontbulger 0.6s ease-in';
    htmlcode.style.display = 'block';
    
    setTimeout(() => {
        htmlcode.style.display = 'none';
    }, 4000)
    htmlcode.addEventListener('mouseenter', () => {
        window.clearTimeout(); // to test
    })
    // document.querySelector(htmlcode)
    //     .fadeIn('slow')
    //     .on('mouseenter', function() {
    //         clearTimeout(notificationTimeout);
    //     });

    //callback for notification removing
    // var removeNoteItem = function () {
    //     htmlcode.remove();
    // };

    // document.querySelector(close).on('click', function () {
    //     $(htmlcode).fadeOut('slow', removeNoteItem);
    // });

    //timeout (if set)
    // if (timeout > 0) {
    //     notificationTimeout = setTimeout(function () {
    //         $(htmlcode).fadeOut('slow', removeNoteItem);
    //     }, timeout);
    // }
}

export { hasClass, addClass, removeClass, displayBarNotification }